import React from 'react'
import { Box, Flex, Label, Text, Tooltip } from '@workwhile/ui'
import { formatInTimeZone } from 'date-fns-tz'
import { JetClockOutCallReport } from 'pages/Shifts/ShiftDetail/types'
import { useShiftDetailContextValue } from '../../../context/ShiftDetailProvider'

type JetWorkerStatusProps = {
  report: JetClockOutCallReport | null | undefined
  requiresJetClockOutCallReport: boolean
}

export const JetWorkerStatus = ({
  report,
  requiresJetClockOutCallReport,
}: JetWorkerStatusProps) => {
  const {
    state: {
      location: {
        address: { timezone },
      },
    },
  } = useShiftDetailContextValue()

  if (!requiresJetClockOutCallReport) {
    return null
  }

  if (!report) {
    return (
      <Box as="span">
        <Label
          variant="none"
          size="small"
          style={{ whiteSpace: 'nowrap', padding: '0 0.5rem' }}
        >
          No JET report
        </Label>
      </Box>
    )
  }

  const mealBreakStartedAt = report.mealBreakStartedAt
    ? formatInTimeZone(
        report.mealBreakStartedAt,
        timezone,
        'EEEE, MMMM d, h:mm a z'
      )
    : null
  const mealBreakEndedAt = report.mealBreakEndedAt
    ? formatInTimeZone(
        report.mealBreakEndedAt,
        timezone,
        'EEEE, MMMM d, h:mm a z'
      )
    : null
  const syncedAt = report.syncedAt
    ? formatInTimeZone(report.syncedAt, timezone, 'EEEE, MMMM d, h:mm a z')
    : null

  const tooltipLabel = (
    <Flex flexDirection="column" gap={1}>
      <Text fontWeight="bold">JET clock-out call report:</Text>
      <Text>Manager: {report.managerName || '-'}</Text>
      <Text>Meal break start: {mealBreakStartedAt || '-'}</Text>
      <Text>Meal break end: {mealBreakEndedAt || '-'}</Text>
      <Text>Temp labor ID: {report.tempLaborId || '-'}</Text>
      <Text>
        Timesheet photo:{' '}
        {report.hasTimesheetPhoto ? 'Attached' : 'Not attached'}
      </Text>
      <Text>Synced: {syncedAt || '-'}</Text>
    </Flex>
  )

  return (
    <Tooltip content={tooltipLabel}>
      <Box as="span">
        <Label
          variant={report.hasTimesheetPhoto ? 'success' : 'warning'}
          size="small"
          style={{ whiteSpace: 'nowrap', padding: '0 0.5rem' }}
        >
          JET report submitted
        </Label>
      </Box>
    </Tooltip>
  )
}
